import React from 'react'
import Input from '@vero/ui-components/components/input.jsx'
import { EMAIL_REGEX } from '../utils.js'

export default function (props) {
  return (
    <Input
      type='email'
      name='email'
      label='email'
      autoComplete='username'
      pattern={EMAIL_REGEX}
      data-dd-privacy='allow'
      {...props}
    />
  )
}
